import React from "react";
import { Grid, Tooltip, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  RiPencilLine,
  RiPenNibLine,
  RiAttachmentLine,
  RiFileList3Line,
  RiCameraLine,
} from "react-icons/ri";
import {
  formatDateToBR,
  formatHoursToBRWithoutSeconds,
} from "../../../../../../../../../../../utils/time";
import {
  cnpjMask,
  formatDefaultValueSelect,
} from "../../../../../../../../../../../utils/mask";
import {
  capitalizeWords,
  formatCPF,
  removeConsecutiveDuplicatesWord,
} from "../../../../../../../../../../../utils/utils";
import LabelAcessoUsuario from "../../LabelAcessoUsuario";
import LabelResultadoDevolutiva from "../../LabelResultadoDevolutiva";

export const StyledPaper = styled(Paper)(() => ({
  backgroundColor: "#FFFFFF",
  width: 30,
  height: 30,
  borderRadius: 50,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
}));

export const tableColumnsGerencial = ({
  setModalAnotacao,
  setModalOrientacao,
  setModalAttachment,
  setModalImages,
  setModalSignature,
  setModalDevolutiva,
  handleRedirectToRegistroSas,
}: any) => [
  {
    id: "id",
    label: "Cód.",
    minWidth: 5,
  },
  {
    id: "dataAtendimento",
    label: "Data",
    orderBy: "dataAtendimento",
    minWidth: 10,
    customField: formatDateToBR,
  },
  {
    id: "dataAtendimento",
    label: "Hora",
    orderBy: "hora",
    minWidth: 5,
    customField: formatHoursToBRWithoutSeconds,
  },
  {
    id: "administrador",
    label: "CPF",
    orderBy: "administrador.cpf",
    minWidth: 105,
    customField: ({ cpf }: any) => formatCPF(cpf),
  },
  {
    id: "empreendedor",
    label: "CNPJ",
    orderBy: "empreendedor.cnpj",
    minWidth: 130,
    customField: (data: any) => cnpjMask(data?.cnpj),
  },
  {
    id: "empreendedor",
    label: "Porte",
    orderBy: "empreendedor.dadoComplementar.porte.sigla",
    customField: (data: any) => {
      return (
        data?.dadoComplementar?.porte?.sigla ?? data?.porteApp?.sigla ?? ""
      );
    },
    minWidth: 5,
  },
  {
    id: "empreendedor",
    label: "UF",
    minWidth: 5,
    orderBy: "empreendedor.dadoComplementar.siglaEstado",
    customField: (data: any) => {
      return data?.dadoComplementar?.siglaEstado || data?.uf || data?.uf?.sigla;
    },
  },
  {
    id: "empreendedor",
    label: "Cidade",
    minWidth: 50,
    orderBy: "empreendedor.dadoComplementar.cidade",
    customField: (data: any) =>
      formatDefaultValueSelect(data?.dadoComplementar?.cidade || data?.cidade),
  },
  {
    id: "nomeAtendente",
    label: "Agente",
    minWidth: 80,
    customField: (value: any) =>
      capitalizeWords(removeConsecutiveDuplicatesWord(value)),
  },
  {
    id: "id",
    label: "OBS",
    sortable: false,
    minWidth: "120px",
    customField: (_: any, data: any) => {
      const { assinaturas, anexos, descricao, planoAcao, imagens, devolutiva } =
        data;

      const anexosFiltrados = anexos?.filter((i: any) => i?.pdf?.nome);
      return (
        <Grid
          container
          justifyContent="space-around"
          wrap="nowrap"
          style={{
            padding: "0 10px",
            margin: "0px 15px",
          }}
        >
          <Tooltip title="Exibir anotações">
            <StyledPaper
              onClick={() =>
                descricao && setModalAnotacao({ open: true, data })
              }
            >
              <RiPencilLine
                size={15}
                color={descricao ? "#0041D9" : "#555770"}
              />
            </StyledPaper>
          </Tooltip>

          <Tooltip title="Exibir orientação">
            <StyledPaper
              onClick={() =>
                planoAcao && setModalOrientacao({ open: true, data })
              }
            >
              <RiFileList3Line
                size={15}
                color={planoAcao ? "#0041D9" : "#555770"}
              />
            </StyledPaper>
          </Tooltip>

          <Tooltip
            title={anexosFiltrados?.length ? "Exibir anexos" : "Nenhum anexo"}
          >
            <StyledPaper
              onClick={() => {
                if (anexosFiltrados?.length)
                  setModalAttachment({ open: true, data });
              }}
            >
              <RiAttachmentLine
                size={15}
                color={anexosFiltrados?.length ? "#0041D9" : "#555770"}
              />
            </StyledPaper>
          </Tooltip>

          <Tooltip title={"Exibir imagem"}>
            <StyledPaper
              onClick={() => {
                if (imagens?.length) {
                  setModalImages({ open: true, data: imagens });
                }
              }}
            >
              <RiCameraLine
                size={15}
                color={!imagens?.length ? "#555770" : "#0041D9"}
              />
            </StyledPaper>
          </Tooltip>

          <Tooltip
            title={
              assinaturas?.length
                ? "Exibir assinatura digital"
                : "Não assinado digitalmente"
            }
            onClick={() => {
              if (assinaturas?.length) setModalSignature({ open: true, data });
            }}
          >
            <StyledPaper>
              <RiPenNibLine
                size={15}
                color={assinaturas?.length ? "#0041D9" : "#555770"}
              />
            </StyledPaper>
          </Tooltip>

          {!!devolutiva && (
            <Tooltip title="Resultado devolutiva">
              <StyledPaper
                onClick={() =>
                  setModalDevolutiva({ open: true, data: devolutiva })
                }
              >
                <LabelResultadoDevolutiva devolutiva={devolutiva} />
              </StyledPaper>
            </Tooltip>
          )}

          <Tooltip title={data?.acesso ? "Acessou o app" : "Não acessou o app"}>
            <StyledPaper
              onClick={() =>
                handleRedirectToRegistroSas(data?.administrador?.cpf)
              }
            >
              <LabelAcessoUsuario data={data} />
            </StyledPaper>
          </Tooltip>
        </Grid>
      );
    },
  },
];
